<router-outlet></router-outlet><simple-notifications [options]="notificationOptions"></simple-notifications>


// WEBPACK FOOTER //
// /app/src/app/app.component.ts.AppComponent.html